export default "__VITE_ASSET__DoQXeyaM__"